import { render, staticRenderFns } from "./MarketSpecificSettings.vue?vue&type=template&id=13a96573&scoped=true&"
import script from "./MarketSpecificSettings.vue?vue&type=script&lang=js&"
export * from "./MarketSpecificSettings.vue?vue&type=script&lang=js&"
import style0 from "./MarketSpecificSettings.vue?vue&type=style&index=0&id=13a96573&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a96573",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/MarketSpecificSettings.vue
// module id = null
// module chunks = 